import React, { forwardRef, useState, useEffect } from "react";
import cx from 'classnames';
import IStyledProps from "../../utilities/IStyledProps";
import IEditableProps from "../../utilities/IEditableProps";
import { BlogResults } from "./BlogResultsV2";
import useQueryParam from '../../utilities/useQueryParam';
import { BlogSubnav, HorizontalParallaxText } from '../../../';
import styled from 'styled-components';
import { Container } from "react-bootstrap";

const ParallaxTextWrapper = styled.div`
   width: 100%;

   @media (min-width: 992px) {
       margin-bottom: -2.6rem;
   }

   /* Prevent text wrapping on mobile */
   .must-reads-parallax {
        white-space: nowrap;
        overflow: hidden;
        max-width: 100%;
     
        /* Adjust font size on smaller screens to fit content */
        @media (max-width: 991px) {
            font-size: 80%;
            letter-spacing: -0.5px; 
            margin-top: 1.75rem;
            margin-bottom: -1.6rem;
       
            h2.parallax-text {
                margin-left: 6rem !important;
            }
        }
   }
`;

export interface IParamNavProps extends IStyledProps, IEditableProps {
    category?: string;
}

const BlogCategoryPageV2 = forwardRef((props: IParamNavProps, ref: any) => {
    const [selectedCategory, setSelectedCategory] = useState(props.category || "All");
    const [tag] = useQueryParam('tag', '');
    const [query] = useQueryParam('q', '');

    useEffect(() => {
        if (props.category) {
            setSelectedCategory(props.category);
        }
    }, [props.category]);

    const getHeaderText = () => {
        if (tag) {
            return tag;
        }
        if (selectedCategory && selectedCategory !== "All") {
            return selectedCategory;
        }
        // Default header
        return "MUST READS";
    };

    const handleCategoryChange = (category: string) => {
        setSelectedCategory(category);
        
        // // Update URL without full page reload
        // if (window.history) {
        //     const newUrl = new URL(window.location.href);
        //     newUrl.pathname = `/must-reads/${category.toLowerCase()}`;
        //     window.history.pushState({ category }, '', newUrl.toString());
        // }
    };

    return (
        <>
            <BlogSubnav />
            <ParallaxTextWrapper>
                <HorizontalParallaxText 
                    text={getHeaderText() || "Must Reads"} 
                    buildrClassName="must-reads-parallax" 
                    outlineColor="outline-redRock"
                />
            </ParallaxTextWrapper>
            <Container ref={ref} data-id={props.cmsId} className={`sing ${cx(props.editorClassObj)}`}>
                <div>
                    <div className="container">
                        <div className="d-flex flex-wrap">
                            <BlogResults 
                                limit={9} 
                                category={selectedCategory} 
                                tag={tag} 
                                query={query} 
                                onCategoryChange={handleCategoryChange}
                            />
                        </div>
                    </div>
                </div>
            </Container>
        </>
    );
});

export default BlogCategoryPageV2;